const locations = {
  nc: [
    {
      label: 'Province-Sud',
      id: 'Province-Sud',
      options: [
        { value: 'Boulouparis', label: 'Boulouparis' },
        { value: 'Bourail', label: 'Bourail' },
        { value: 'Dumbéa', label: 'Dumbéa' },
        { value: 'Farino', label: 'Farino' },
        { value: 'Île des Pins', label: 'Île des Pins' },
        { value: 'La Foa', label: 'La Foa' },
        { value: 'Moindou', label: 'Moindou' },
        { value: 'Mont-Dore', label: 'Mont-Dore' },
        { value: 'Nouméa', label: 'Nouméa' },
        { value: 'Païta', label: 'Païta' },
        { value: 'Poya', label: 'Poya' },
        { value: 'Sarraméa', label: 'Sarraméa' },
        { value: 'Thio', label: 'Thio' },
        { value: 'Yaté', label: 'Yaté' },
      ],
    },
    {
      label: 'Province-Nord',
      id: 'Province-Nord',
      options: [
        { value: 'Bélep', label: 'Bélep' },
        { value: 'Canala', label: 'Canala' },
        { value: 'Hienghène', label: 'Hienghène' },
        { value: 'Houaïlou', label: 'Houaïlou' },
        { value: 'Kaala-Gomen', label: 'Kaala-Gomen' },
        { value: 'Koné', label: 'Koné' },
        { value: 'Kouaoua', label: 'Kouaoua' },
        { value: 'Koumac', label: 'Koumac' },
        { value: 'Ouégoa', label: 'Ouégoa' },
        { value: 'Poindimié', label: 'Poindimié' },
        { value: 'Ponerihouen', label: 'Ponerihouen' },
        { value: 'Pouébo', label: 'Pouébo' },
        { value: 'Pouembout', label: 'Pouembout' },
        { value: 'Poum', label: 'Poum' },
        { value: 'Touho', label: 'Touho' },
        { value: 'Voh', label: 'Voh' },
      ],
    },
    {
      label: 'Îles Loyauté',
      id: 'Îles Loyauté',
      options: [
        { value: 'Lifou', label: 'Lifou' },
        { value: 'Maré', label: 'Maré' },
        { value: 'Ouvéa', label: 'Ouvéa' },
      ],
    },
  ],
  pf: [
    {
      label: 'Communes',
      id: 'Communes',
      options: [
        { value: 'Afaahiti', label: 'Afaahiti' },
        { value: 'Afareaitu', label: 'Afareaitu' },
        { value: 'Anau', label: 'Anau' },
        { value: 'Arue', label: 'Arue' },
        { value: 'Atiha', label: 'Atiha' },
        { value: 'Avera', label: 'Avera' },
        { value: 'Faaa', label: 'Faaa' },
        { value: 'Faanui', label: 'Faanui' },
        { value: 'Faaone', label: 'Faaone' },
        { value: 'Fetuna', label: 'Fetuna' },
        { value: 'Haapiti', label: 'Haapiti' },
        { value: 'Haumi', label: 'Haumi' },
        { value: 'Hitiaa', label: 'Hitiaa' },
        { value: 'Hitiaa O Te Ra', label: 'Hitiaa O Te Ra' },
        { value: 'Maeva', label: 'Maeva' },
        { value: 'Mahaena', label: 'Mahaena' },
        { value: 'Mahanatoa', label: 'Mahanatoa' },
        { value: 'Maharepa', label: 'Maharepa' },
        { value: 'Mahina', label: 'Mahina' },
        { value: 'Mataiea', label: 'Mataiea' },
        { value: 'Mataura', label: 'Mataura' },
        { value: 'Moerai', label: 'Moerai' },
        { value: 'Motu Tiapa', label: 'Motu Tiapa' },
        { value: 'Nukumaru', label: 'Nukumaru' },
        { value: 'Nunue', label: 'Nunue' },
        { value: 'Opoa', label: 'Opoa' },
        { value: 'Opunohu', label: 'Opunohu' },
        { value: 'Paea', label: 'Paea' },
        { value: 'Pao pao', label: 'Pao pao' },
        { value: 'Papara', label: 'Papara' },
        { value: 'Papeari', label: 'Papeari' },
        { value: 'Papeete', label: 'Papeete' },
        { value: 'Papenoo', label: 'Papenoo' },
        { value: 'Papetoai', label: 'Papetoai' },
        { value: 'Pihaena', label: 'Pihaena' },
        { value: 'Pirae', label: 'Pirae' },
        { value: 'Punaauia', label: 'Punaauia' },
        { value: 'Puohine', label: 'Puohine' },
        { value: 'Rairua', label: 'Rairua' },
        { value: 'Taiarapu-Est', label: 'Taiarapu-Est' },
        { value: 'Taiarapu-Ouest', label: 'Taiarapu-Ouest' },
        { value: 'Taiohae', label: 'Taiohae' },
        { value: 'Taputapuatea', label: 'Taputapuatea' },
        { value: 'Taravao', label: 'Taravao' },
        { value: 'Tautira', label: 'Tautira' },
        { value: 'Teahupoo', label: 'Teahupoo' },
        { value: 'Teavaro', label: 'Teavaro' },
        { value: 'Tehurui', label: 'Tehurui' },
        { value: 'Temae', label: 'Temae' },
        { value: 'Tevaitoa', label: 'Tevaitoa' },
        { value: 'Teva I Uta', label: 'Teva I Uta' },
        { value: 'Tiarei', label: 'Tiarei' },
        { value: 'Tiputa', label: 'Tiputa' },
        { value: 'Toahotu', label: 'Toahotu' },
        { value: 'Tumaraa', label: 'Tumaraa' },
        { value: 'Uturoa', label: 'Uturoa' },
        { value: 'Vaiaau', label: 'Vaiaau' },
        { value: 'Vaiare', label: 'Vaiare' },
        { value: 'Vairao', label: 'Vairao' },
        { value: 'Vaitape', label: 'Vaitape' },
      ],
    },
    {
      label: 'Îles',
      id: 'Îles',
      options: [
        { value: 'Ahe', label: 'Ahe' },
        { value: 'Aratika', label: 'Aratika' },
        { value: 'Bora-Bora', label: 'Bora-Bora' },
        { value: 'Fakarava', label: 'Fakarava' },
        { value: 'Huahine', label: 'Huahine' },
        { value: 'Maiao', label: 'Maiao' },
        { value: 'Manihi', label: 'Manihi' },
        { value: 'Marquises', label: 'Marquises' },
        { value: 'Maupiti', label: 'Maupiti' },
        { value: 'Mehetia', label: 'Mehetia' },
        { value: 'Moorea', label: 'Moorea' },
        { value: 'Nengo Nengo', label: 'Nengo Nengo' },
        { value: 'Nuku Hiva', label: 'Nuku Hiva' },
        { value: 'Raiatea', label: 'Raiatea' },
        { value: 'Raivavae', label: 'Raivavae' },
        { value: 'Rangiroa', label: 'Rangiroa' },
        { value: 'Raraka', label: 'Raraka' },
        { value: 'Rurutu', label: 'Rurutu' },
        { value: 'Tahaa', label: 'Tahaa' },
        { value: 'Tahiti', label: 'Tahiti' },
        { value: 'Tenukupara', label: 'Tenukupara' },
        { value: 'Tetiaroa', label: 'Tetiaroa' },
        { value: 'Tikehau', label: 'Tikehau' },
        { value: 'Tubuai', label: 'Tubuai' },
      ],
    },
  ],
  vn: [
    {
      label: 'Shefa',
      id: 'Shefa',
      options: [{ value: 'Port-Vila', label: 'Port-Vila' }],
    },
    {
      label: 'Sanma',
      id: 'Sanma',
      options: [
        { value: 'Luganville', label: 'Luganville' },
        { value: 'Port-Olry', label: 'Port-Olry' },
      ],
    },
    {
      label: 'Malampa',
      id: 'Malampa',
      options: [
        { value: 'Lakatoro', label: 'Lakatoro' },
        { value: 'Fanla', label: 'Fanla' },
      ],
    },
    {
      label: 'Tafea',
      id: 'Tafea',
      options: [
        { value: 'Isangel', label: 'Isangel' },
        { value: 'Lenakel', label: 'Lenakel' },
      ],
    },
    {
      label: 'Penama',
      id: 'Penama',
      options: [
        { value: 'Saratamata', label: 'Saratamata' },
        { value: 'Norsup', label: 'Norsup' },
      ],
    },
    {
      label: 'Torba',
      id: 'Torba',
      options: [{ value: 'Sola', label: 'Sola' }],
    },
  ],
};

export default locations[process.env.APP_LOCALIZATION];
